import Swiper, { EffectCoverflow, Pagination } from 'swiper';
import gsap from "gsap/all";
import usefull from './useful';
import 'swiper/css'
import 'swiper/css/bundle'
import 'swiper/bundle'
import VideoPlayer from './ComponentVideos';


// COMPOSANT BLOC SLIDERS

export default function ComponentSlider() {
    const compSliders = document.querySelectorAll('.c-slider')
    if (compSliders.length > 0) {
        compSliders.forEach(comp => new Slider(comp))
    }
}


class Slider {
    constructor(DOM) {
        this.DOM = DOM;
        this.createSlider()
            .then(() => {
                this.createContent()
            }).then(() => this.animateOnEnter());

        this.content = {
            videos: []
        }
    }
    async createSlider() {
        let initialSlide = usefull.isMobile() ? 0 : 1;
        let showRatio = usefull.isMobile() ? 1.4 : 2.25;

        const swiper = new Swiper('.c-slider__swiper', {
            modules: [Pagination, EffectCoverflow],
            initialSlide: initialSlide,
            grabCursor: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            slidesPerView: showRatio,
            spaceBetween: 20,
            grabCursor: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },

        });

        swiper.on('activeIndexChange', e => {
            this.content.videos.forEach(video => video.destroy())
        })

        
    }

    createContent() {
        let videos = this.DOM.querySelectorAll('.c-video__video')
        if (videos.length > 0) {
            let obj = [];
            videos.forEach(video => {
                let lesvideos = new VideoPlayer(video, true)

                video.addEventListener('click', () =>{
                    lesvideos.playVideo()
                })
                obj.push(lesvideos)
            })
            this.content.videos = obj
        }
    }


    animateOnEnter() {
        gsap.from(this.DOM.querySelectorAll('.c-slider__item, .c-slider__pagination, .c-slider__button '), {
            scrollTrigger: this.DOM,
            autoAlpha: 0,
            duration: 1,
            delay: .2,
            stagger: 0.1
        })
    }
}





